module.exports = __webpack_public_path__ + "img/eff05Bigpc.397e622d.png";